import swal from "sweetalert2";

/**
 * El aviso de los editores (etapa y proyecto) cuando guardarProyecto rechaza
 * el guardado (plan de etapas y versiones §5.8 A; el texto sale de
 * rechazoDelGuardado). El servidor no guardó nada ni mandó correos ni tocó
 * GitLab, así que el editor se queda abierto con lo capturado. Ojo: el editor
 * de proyecto sube a GitLab los archivos nuevos ANTES de guardar; esos sí
 * quedaron allá y el texto lo dice (avisoArchivosSinLigar).
 */
export function mostrarRechazoDelGuardado(texto: string): void {
  swal.fire({
    title: "No se guardó",
    text: texto,
    icon: "error",
    buttonsStyling: false,
    customClass: { confirmButton: "btn btn-success" },
    confirmButtonText: "Aceptar",
  });
}

/**
 * Lo que se agrega al texto del rechazo cuando el editor de proyecto ya había
 * subido archivos a GitLab: están en el repositorio, pero el proyecto no los
 * lista hasta que un guardado entre. "" si no subió ninguno.
 */
export function avisoArchivosSinLigar(archivos: readonly string[]): string {
  if (!archivos.length) {
    return "";
  }
  const cuales = archivos.join(", ");
  return archivos.length === 1
    ? ` El archivo ${cuales} ya se subió al repositorio de GitLab, pero el proyecto no lo lista hasta que se guarde; si vuelves a guardar desde aquí no se sube otra vez.`
    : ` Los archivos ${cuales} ya se subieron al repositorio de GitLab, pero el proyecto no los lista hasta que se guarde; si vuelves a guardar desde aquí no se suben otra vez.`;
}
